const NewsletterCTA = () => {
  return (
    <section className="relative h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/921f1eb1740769273203631f80a2ea59.jpg"
          alt="Campfire at Sunset"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative h-full max-w-7xl mx-auto px-6 flex flex-col justify-between py-20">
        <div>
          <h2 className="font-serif text-6xl font-bold text-white lowercase leading-tight">
            never miss<br />
            an adventure
          </h2>
        </div>

        <div className="flex items-end justify-between">
          <a
            href="#subscribe"
            className="group px-8 py-4 bg-white rounded-full flex items-center gap-3 hover:bg-cream transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="font-sans font-medium text-gray-900">Subscribe Now</span>
            <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-line text-white text-lg"></i>
            </div>
          </a>

          <div className="text-right">
            <p className="text-white text-xl font-light leading-relaxed">
              Get weekly camping tips and<br />
              destination guides in your inbox
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterCTA;